import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useRouter } from '../../../../../@casino/useRouter';
import { setViewGroups } from '../../store/thunk/setGetViewGroup';
import { useDispatch, useSelector } from 'react-redux';
import BetBlock from '../../components/betBlock';
import { setGetGamerInformation } from '../../store/thunk/setGetGamerInformation';
import { setGetOperatorDetalization } from '../../store/thunk/setGetOperatorDetalization';
import { setGetOperatorDetalizationAction } from '../../store/action';
import { setGetBet } from '../../store/thunk/setGetBet';
import Dialog from '@material-ui/core/Dialog';
import { setPostUpdateBalance } from '../../store/thunk/setPostUpdateBalance';
import moment from 'moment';

const View = () => {
    const utc = moment.utc().valueOf();
    const dispatch = useDispatch();
    const router = useRouter();
    const {id} = router.query;
    const [active, setActive] = React.useState('bet');
    const [subActive, setSubActive] = React.useState('cashier');
    const currentDate = utc
    const [openAddModal, setOpenAddModal] = React.useState(false);

    React.useEffect(() => {
        dispatch(setViewGroups({
            id
        }));   
    }, [id])

    const view = useSelector(state => state.cashiersMobile.view);

    React.useEffect(() => {
        if (view?.groups) {
            dispatch(setGetGamerInformation({
                groups: view.groups
            }))
            dispatch(setGetOperatorDetalization({
                group: view.groups,
                date_from: 0,
                date_to: currentDate,
                air: false
            }))
            dispatch(setGetBet({
                groups: view.groups,
                date_from: 0,
                date_to: currentDate
            }))
        }
        // eslint-disable-next-line
    }, [view.groups]);

    const countUser = useSelector(state => state.cashiersMobile.gamer_information);
    const detalization = useSelector(state => state.cashiersMobile.detalization);
    const bet = useSelector(state => state.cashiersMobile.bet);

    return (
        <TemplatePage
            title={view.groups}
        >
            <div style={{width: '100%'}}>
                <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', padding: 20}}>
                    <div>
                        <span style={{
                            color: 'hsla(0,0%,100%,.5)',
                            width: 60,
                            fontSize: 16,
                            textAlign: 'right',
                            fontFamily: 'PT-sans, sans-serif',
                            marginRight: 12
                        }}>
                            Количество игроков
                        </span>
                        <span style={{
                            color: '#fff',
                            width: 60,
                            fontSize: 16,
                            textAlign: 'right',
                            fontFamily: 'PT-sans, sans-serif',
                            marginRight: 12
                        }}>
                            {countUser.count_gamer}
                        </span>
                    </div>
                    <div>
                        <span style={{
                            color: 'hsla(0,0%,100%,.5)',
                            width: 60,
                            fontSize: 16,
                            textAlign: 'right',
                            fontFamily: 'PT-sans, sans-serif',
                            marginRight: 12
                        }}>
                            Баланс:
                        </span>
                        <span style={{
                            color: '#fff',
                            width: 60,
                            fontSize: 16,
                            textAlign: 'right',
                            fontFamily: 'PT-sans, sans-serif',
                            marginRight: 12
                        }}>
                            {new Intl.NumberFormat('ru-RU').format(view && view.balance ? view.balance : 0)}
                        </span>
                    </div>
                </div>
                <div style={{display: 'flex', width: '100%'}}>
                    <span style={{
                        marginLeft: 12,
                        padding: 5,
                        color: 'rgb(47, 47, 47)',
                        background: 'gold',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                        onClick={() => {
                            dispatch(setPostUpdateBalance({
                                amount: 300000,
                                id: view.id,
                                method: 'add'
                            }, setOpenAddModal))
                        }}
                    >
                        Выдать 300 000 кредитов
                    </span>
                </div>
                <div style={{marginTop: 20, width: '100%'}}>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20}}>
                        <span style={{
                            color: 'hsla(0,0%,100%,.5)',
                            width: 60,
                            fontSize: 16,
                            textAlign: 'right',
                            fontFamily: 'PT-sans, sans-serif',
                            marginRight: 12
                        }}>Статистика</span>
                    </div>
                    <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: 20}}>
                        <span 
                            onClick={() => setActive('bet')}
                            style={{width: '50%', color: active === 'bet' ? '#fff' : 'hsla(0,0%,100%,.5)', display: 'flex', justifyContent: 'center', borderBottom: active === 'bet' && '1px solid rgb(55, 135, 255)', paddingBottom: 10}}>
                            Ставки
                        </span>
                        <span 
                            onClick={() => setActive('cashier')}
                            style={{width: '50%', color: active === 'cashier' ? '#fff' : 'hsla(0,0%,100%,.5)', display: 'flex', justifyContent: 'center', borderBottom: active === 'cashier' && '1px solid rgb(55, 135, 255)', paddingBottom: 10}}>
                            Касса
                        </span>
                    </div>
                    {
                        active === 'cashier' &&
                        <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: 20}}>
                            <span 
                                onClick={() => {
                                    setSubActive('cashier');
                                    dispatch(setGetOperatorDetalizationAction([]));
                                    dispatch(setGetOperatorDetalization({
                                        group: view.groups,
                                        date_from: 0,
                                        date_to: currentDate,
                                        air: false
                                    }))
                                }}
                                style={{width: '33%', color: subActive === 'cashier' ? '#fff' : 'hsla(0,0%,100%,.5)', display: 'flex', justifyContent: 'center', borderBottom: subActive === 'cashier' && '1px solid rgb(55, 135, 255)', paddingBottom: 10}}>
                                Касса
                            </span>
                            <span 
                                onClick={() => {
                                    setSubActive('air');
                                    dispatch(setGetOperatorDetalizationAction([]))
                                    dispatch(setGetOperatorDetalization({
                                        group: view.groups,
                                        date_from: 0,
                                        date_to: currentDate,
                                        air: true
                                    }))
                                }}
                                style={{width: '33%', color: subActive === 'air' ? '#fff' : 'hsla(0,0%,100%,.5)', display: 'flex', justifyContent: 'center', borderBottom: subActive === 'air' && '1px solid rgb(55, 135, 255)', paddingBottom: 10}}>
                                Воздух
                            </span>
                            <span 
                                onClick={() => {
                                    setSubActive('all')
                                    dispatch(setGetOperatorDetalizationAction([]))
                                    dispatch(setGetOperatorDetalization({
                                        group: view.groups,
                                        date_from: 0,
                                        date_to: currentDate,
                                        air: 'all'
                                    }))
                                }}
                                style={{width: '33%', color: subActive === 'all' ? '#fff' : 'hsla(0,0%,100%,.5)', display: 'flex', justifyContent: 'center', borderBottom: subActive === 'all' && '1px solid rgb(55, 135, 255)', paddingBottom: 10}}>
                                Всего
                            </span>
                        </div>
                    }
                </div>
                <div>
                    {
                        active === 'bet' && <BetBlock 
                                                label1="Сумма ставок"
                                                label2="Сумма выигрышей"
                                                label3="Количество ставок"
                                                label4="Разница" 
                                                amount1={new Intl.NumberFormat('ru-RU').format(bet.sumBet ? bet.sumBet.toFixed(2) : 0)}
                                                amount2={new Intl.NumberFormat('ru-RU').format(bet.sumWin ? bet.sumWin.toFixed(2) : 0)}
                                                amount3={new Intl.NumberFormat('ru-RU').format(+bet.countBet ? +bet.countBet : 0)}
                                                amount4={new Intl.NumberFormat('ru-RU').format(bet.sumBet ? (bet.sumBet - bet.sumWin).toFixed(2) : 0)}  
                                            />
                    }
                    {
                        active === 'cashier' && <BetBlock 
                                                label1="Вход"
                                                label2="Выход"
                                                label3="Количество операций"
                                                label4="Разница" 
                                                amount1={new Intl.NumberFormat('ru-RU').format(detalization.sumDeposit ? detalization.sumDeposit.toFixed(2) : 0)}
                                                amount2={new Intl.NumberFormat('ru-RU').format(detalization.sumWithdrawal ? detalization.sumWithdrawal.toFixed(2) : 0)}
                                                amount3={new Intl.NumberFormat('ru-RU').format(detalization.count ? detalization.count : 0)}
                                                amount4={new Intl.NumberFormat('ru-RU').format(detalization.sumDeposit ? (detalization.sumDeposit - detalization.sumWithdrawal).toFixed(2) : 0)}
                                            />
                    }
                </div>
            </div>   
            <Dialog onClose={() => setOpenAddModal(false)} open={openAddModal}>
                <div style={{padding: 20}}>
                    <div>
                        <span>На кассу добавленно 300 000 кредитов</span>
                    </div>
                    <div style={{width: '100%', display: 'flex', marginTop: 12}} onClick={() => setOpenAddModal(false)}>
                        <span style={{padding: 10, width: '100%', background: 'gold', borderRadius: 4, display: 'flex', justifyContent: 'center'}}>Закрыть</span>
                    </div>
                </div>
            </Dialog>
        </TemplatePage>
    )
}

export default View;